import { user } from '../api/user';

export function current_user() {
   return user().catch(e => {
     return false
   })
}
